import { render, staticRenderFns } from "./SparringRoundScoreEditor.vue?vue&type=template&id=55ce6cf5&scoped=true"
import script from "./SparringRoundScoreEditor.vue?vue&type=script&lang=js"
export * from "./SparringRoundScoreEditor.vue?vue&type=script&lang=js"
import style0 from "./SparringRoundScoreEditor.vue?vue&type=style&index=0&id=55ce6cf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ce6cf5",
  null
  
)

export default component.exports